import { eventEmitter, getEventBus } from '../namespaces'

export const ShellNamespace = 'Shell'

export class AsyncEvent extends Event {
  constructor(type: string, eventInitDict?: EventInit) {
    super(type, eventInitDict)
  }

  private promises: Promise<void>[] = []

  /**
   * Add a promise to the list of promises to be settled before the allSettled promise resolves
   * @param promise
   */
  waitFor(promise: Promise<void>) {
    this.promises.push(promise)
  }

  /**
   * A promise that resolves when all of the `waitFor` promises have settled (resolved/rejected)
   */
  async allSettled() {
    await Promise.allSettled(this.promises)
  }
}

/**
 * Event that is emitted over the event bus when a browser reload is requested
 */
export class ShellReloadEvent extends AsyncEvent {
  constructor() {
    super('shellReloadEvent', { cancelable: true })
  }
}

export interface ShellAppChangedEventsPayload {
  readonly from: readonly string[]
  readonly to: readonly string[]
}

export const shellEvents = {
  /**
   * event to be emitted when a browser reload is required.
   */
  reloadPage: eventEmitter<ShellReloadEvent>(),

  /**
   * appChanged will be fired every time a mounted extension change
   * ex: appChanged({
   *   from: ['experience1']
   *   to: ['experience2']
   * })
   */
  appChanged: eventEmitter<ShellAppChangedEventsPayload>(),

  /**
   * routeChanged event will be emitted every time the app routing changes.
   */
  routeChanged: eventEmitter<void>(),
}
const { emit } = getEventBus().register<typeof shellEvents>(ShellNamespace, shellEvents)

export const appChangedEvent = (payload: ShellAppChangedEventsPayload) => {
  emit.appChanged(payload)
}

export const routeChangedEvent = () => emit.routeChanged()

getEventBus().register(ShellNamespace, shellEvents)
